import { render } from "./SingleUpload.vue?vue&type=template&id=dbe20bcc"
import script from "./SingleUpload.vue?vue&type=script&lang=js"
export * from "./SingleUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__